function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M81 40.305c.06 22.227-17.773 40.367-40 40.69a39.407 39.407 0 01-28.212-11.29A39.406 39.406 0 011 41.7C.94 19.472 18.772 1.33 41 1.004a39.41 39.41 0 0140 39.301zm-40 5.912V21.87"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 4,
  d: "M40.991 58.391h.018"
}));

function SvgAlertWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82
  }, props), _ref);
}

export default SvgAlertWhite;